<template>
  <v-dialog v-model="show" persistent>
    <v-card class="pa-3">
      <span class="title">Dados Bancários</span>

      <v-flex xs12 sm6>
        <v-text-field
          label="Nome Completo"
          v-model="account.nome"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6>
        <v-text-field
          label="CPF"
          v-mask="'###.###.###-##'"
          v-model="account.cpf"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field label="Banco" v-model="account.banco"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field
          label="Agência"
          v-mask="'###########'"
          v-model="account.agencia"
        ></v-text-field>
      </v-flex>
      <v-layout row ma-0 justify-space-between>
        <v-flex xs7>
          <v-text-field
            label="Conta"
            v-mask="'#############'"
            v-model="account.conta"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            label="Dígito"
            v-mask="'#'"
            v-model="account.digito"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-text-field
          label="Tipo de Conta"
          v-model="account.tipo_conta"
        ></v-text-field>
      </v-flex>

      <v-layout row ma-0 justify-center>
        <v-btn class="ma-0 success" @click="submit()">
          <span class="white--text">ok</span>
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },

  data() {
    return {
      account: {
        nome: null,
        cpf: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        tipo_conta: null,
      },
    };
  },

  methods: {
    submit() {
      if (
        this.account.nome &&
        this.account.cpf &&
        this.account.banco &&
        this.account.agencia &&
        this.account.conta &&
        this.account.digito &&
        this.account.tipo_conta
      ) {
        this.$emit('setDataAccoutUser', this.account);
        this.$emit('close');
      } else this.$emit('snackbar');
    },
  },
};
</script>
